import React from 'react'
import styled from 'styled-components';
import CupoySrefView from 'components/commons/router/CupoySrefView';

const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
`

const Title = styled.div`
  color: ${props => props.highlight? '#F75C2F' : '#4a4a4a'};
  cursor: pointer;
`

const Icon = styled.i`
  margin: 0 16px;
  font-size: 20px;
  color: #9B9B9B;
  font-weight: bold;
`

export default props => {
  const { preState, preTitle, title } = props.path;
  return (
    <Container>
      <CupoySrefView statename={preState} >
        <Title highlight >{preTitle}</Title>
      </CupoySrefView>
      <Icon className="zmdi zmdi-chevron-right" />
      <Title>{title}</Title>
    </Container>
  )
}
